import LottieAnimation from "lottie-react";
import type { LottieRefCurrentProps } from "lottie-react";
import type { LottieProps } from "./types";
import React, { useEffect, useRef } from "react";
import { Box } from "../../primitives/box";
import { useStyles } from "./styles";

export const Lottie = ({
  animation,
  loop = true,
  autoPlay = true,
  width,
  height,
  style,
  className,
  speed,
  onComplete,
  ...props
}: LottieProps) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (speed && lottieRef.current) {
      lottieRef.current.setSpeed(speed);
    }
  }, [speed]);

  const styles = useStyles();

  return (
    <Box
      className={`lottie-container ${className ?? ""}`}
      style={{
        ...styles,
        ...(width && {
          "--lottie-container-width":
            typeof width === "number" ? `${width}px` : width,
        }),
        ...(height && {
          "--lottie-container-height":
            typeof height === "number" ? `${height}px` : height,
        }),

        ...(style?.containerStyles ?? {}),
      }}
    >
      <LottieAnimation
        lottieRef={lottieRef}
        animationData={animation}
        loop={loop}
        autoplay={autoPlay}
        onComplete={onComplete}
        className="lottie"
        style={{
          ...((style?.lottieStyles ?? {}) as React.CSSProperties),
        }}
        {...props}
      />
    </Box>
  );
};

Lottie.displayName = "Lottie";
